import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import CheckCircle from "@/components/ui/CheckCircle";

interface Props {
  questions: string[];
}

export const TextQuestions = ({ questions }: Props) => {
  return (
    <div className="rounded-2xl overflow-hidden">
      <div className="bg-accent px-6 pt-6 pb-6">
        <div className="space-y-3">
          {questions.map((question, index) => (
            <div key={index} className="flex items-center gap-3">
              <CheckCircle className="text-sm font-semibold">
                {index + 1}
              </CheckCircle>
              <span className="prose prose-p:inline max-w-full text-base">
                <CourseMarkdown>{question}</CourseMarkdown>
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
